import template from './templates/menu-button-trigger.tpl.html';
const defaultTrigger = '<i class="aci-arrow-bottom icon-states"></i>';

function menuButtonTrigger($log) {
  return {
    restrict: 'E',
    require: ['^akamMenuButton', 'akamMenuButtonTrigger'],
    replace: true,
    transclude: true,
    template,
    scope: {},
    bindToController: {},
    controller: () => {},
    controllerAs: 'menuButtonTrigger',
    link(scope, elem, attrs, [menuBtnCtrl, menuBtnTriggerCtrl]) {
      scope.$watch(() => menuBtnCtrl.isDisabled, isDisabled =>
        menuBtnTriggerCtrl.isDisabled = isDisabled
      );
      menuBtnTriggerCtrl.size = menuBtnCtrl.size;
      if (elem.children().length === 0 && elem.text().trim().length === 0) {
        $log.warn('No content in akam-menu-button-trigger - using default icon.');
        elem.append(defaultTrigger);
      }
    }
  };
}
menuButtonTrigger.$inject = ['$log'];

export default menuButtonTrigger;
